<template>
  <div>
    <div class="row">
      <breadcrumb>
        <template v-slot:1>
          <router-link :to="{ name: 'informes' }">{{
            $t("informes")
          }}</router-link>
        </template>
        <template v-slot:2>Informe de vales</template>
      </breadcrumb>

      <CabeceraInformes
        :idBusiness="idBusiness"
        :listBusinesses="listBusinesses"
        :idTpv="idTpv"
        :listTpv="listTpv"
        :dateto="dateto"
        :datefrom="datefrom"
        id="cabecera"
        :conTodos="true"
      />
      <template v-if="!permiso">
          <div class="alert alert-danger m-3" style="width: 100%" role="alert">
              Lo sentimos. Este negocio no cuenta con este módulo activado.
          </div>
      </template>
      <div class="col-md-12" v-else-if="respuesta" id="mytable">
        <template v-if="dateInform.length > 0">
          <div class="row justify-content-between div-export">
            <div class="col-md-12 text-left">
              <el-dropdown>
                <el-button type="primary" size="small">
                  <i class="fa fa-file"></i>
                  {{ $t("exportarInforme") }}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <a :href="urlExportPDF">
                    <el-dropdown-item class="text-danger">
                      <strong
                        ><i class="fa fa-file-pdf"></i>
                        {{ $t("exportarPdf") }}</strong
                      >
                    </el-dropdown-item>
                  </a>
                  <a :href="urlExportExcel">
                    <el-dropdown-item class="text-success">
                      <strong
                        ><i class="fa fa-file-excel"></i>
                        {{ $t("exportarExcel") }}</strong
                      >
                    </el-dropdown-item>
                  </a>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>

          <div class="table-responsive" style="overflow: auto">
            <table class="table table-bordered table-striped text-nowrap">
              <thead class="thead-dark">
                <tr>
                  <th>
                    <span
                      v-if="ordenarFecha"
                      @click="sortedArrayASC(1), (ordenarFecha = 0)"
                      ><i style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("hash") }}
                    </span>
                    <span v-else @click="sortedArrayDESC(1), (ordenarFecha = 1)"
                      ><i style="color: white" class="fa fa-angle-down"></i>
                      {{ $t("hash") }}
                    </span>
                  </th>
                  <th>
                    <span
                      v-if="ordenarFecha"
                      @click="sortedArrayASC(1), (ordenarFecha = 0)"
                      ><i style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("tpvOrigen") }}
                    </span>
                    <span v-else @click="sortedArrayDESC(1), (ordenarFecha = 1)"
                      ><i style="color: white" class="fa fa-angle-down"></i>
                      {{ $t("tpvOrigen") }}
                    </span>
                  </th>
                  <th>
                    <span
                      v-if="ordenarOperacion"
                      @click="sortedArrayASC(2), (ordenarOperacion = 0)"
                      ><i style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("nombreTpvDestino") }}
                    </span>
                    <span
                      v-else
                      @click="sortedArrayDESC(2), (ordenarOperacion = 1)"
                      ><i style="color: white" class="fa fa-angle-down"></i>
                      {{ $t("nombreTpvDestino") }}
                    </span>
                  </th>

                  <th>
                    <span
                      v-if="ordenarFecha"
                      @click="sortedArrayASC(1), (ordenarFecha = 0)"
                      ><i style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("dateCreacion") }} 
                    </span>
                    <span v-else @click="sortedArrayDESC(1), (ordenarFecha = 1)"
                      ><i style="color: white" class="fa fa-angle-down"></i>
                     {{ $t("dateCreacion") }}                     
                    </span>
                  </th>

                  <th>
                    <span
                      v-if="ordenarFecha"
                      @click="sortedArrayASC(1), (ordenarFecha = 0)"
                      ><i style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("dateConsumo") }}
                    </span>
                    <span v-else @click="sortedArrayDESC(1), (ordenarFecha = 1)"
                      ><i style="color: white" class="fa fa-angle-down"></i>
                      {{ $t("dateConsumo")}}
                    </span>
                  </th>

                  <th>
                    <span
                      v-if="ordenarFecha"
                      @click="sortedArrayASC(1), (ordenarFecha = 0)"
                      ><i style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("validez") }}
                    </span>
                    <span v-else @click="sortedArrayDESC(1), (ordenarFecha = 1)"
                      ><i style="color: white" class="fa fa-angle-down"></i>
                      {{ $t("validez")}}
                    </span>
                  </th>

                  <th>
                    <span
                      v-if="ordenarImporte"
                      @click="sortedArrayASC(3), (ordenarImporte = 0)"
                      ><i style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("total") }}
                    </span>
                    <span
                      v-else
                      @click="sortedArrayDESC(3), (ordenarImporte = 1)"
                      ><i style="color: white" class="fa fa-angle-down"></i>
                      {{ $t("total") }}
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr id="vm" v-for="vale in dateInform">
                  <td>{{vale.hash}}</td>
                  <td>{{vale.nombreTpvOrigen}}</td>
                  <td>{{vale.nombreTpvDestino}}</td>
                  <td>{{vale.dateCreacion | parseDate}}</td>
                  <td v-if="vale.dateConsumo > 0"> {{vale.dateConsumo | parseDate}}</td>
                  <td v-else>{{ $t("sinConsumir") }}</td>
                  <td>{{vale.validez}}</td>
                  <td>{{vale.total | currency}}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr class="table-success">
                  <td><strong>Total:</strong></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td class="text-right"><strong>{{getTotalVales | currency}}</strong></td>
                </tr>
              </tfoot>
            </table>
          </div>
        </template>
        <template v-else>
          <div class="alert alert-danger" role="alert">
            No hay vales en el rango de fechas seleccionado
          </div>
        </template>
      </div>
    </div>

    <modal
      name="desgloseModal"
      :adaptive="true"
      :scrollable="true"
      height="auto"
      :clickToClose="false"
    >
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">{{ $t("desglose") }}</h4>
        </div>
        <div class="modal-body">
          <div
            v-if="dateInform.length > 0"
            class="table-responsive"
            style="overflow: auto"
          >
            <table class="table table-bordered table-striped">
            
              <tbody>
       
                 
                <tr class="table-success">
                  <td>
                    <strong>{{ $t("total") }}</strong>
                  </td>
                  <td align="right">
                    <strong>{{ dateInform[indice].amount | currency }}</strong>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr></tr>
              </tfoot>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" @click="cerrarModal()">
            <i class="fa fa-times-circle"></i> {{ $t("volver") }}
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import {
  DatePicker,
  Select,
  Option,
  Dropdown,
  DropdownItem,
  Loading,
  DropdownMenu,
  Button,
} from "element-ui";
import swal from "sweetalert2";
import moment from "moment";
import Datetime from "vue-datetime";
import Breadcrumb from "@/components/Breadcrumb/Breadcrumb.vue";
import CabeceraInformes from "@/components/CabeceraInformes/CabeceraInformes.vue";
import { mapState } from 'vuex'

export default {
  created() {
    this.loading = Loading.service({ text: "Cargando..." });
    this.$store.dispatch("setNameRoute", "Informe de vales");
    this.getBusiness();

    if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
      this.datefrom = this.$store.getters.dateFrom;
      this.dateto = this.$store.getters.dateTo;
    }
  },
  components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
    [Datetime.name]: Datetime,
    Breadcrumb,
    CabeceraInformes,
  },
  data() {
    return {
      loading: false,
      datefrom: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        1
      ).toISOString(),
      dateto: new Date().toISOString(),
      listBusinesses: [],
      idBusiness: 0,
      data: [""],
      idTpv: 0,
      listTpv: [],
      cuentasAparcadas: false,
      dateInform: ["-"],
      value4: [
        new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        new Date(),
      ],
      indice: 0,

      respuesta: true,

      //ORDENAR
      ordenarFecha: 0,
      ordenarOperacion: 0,
      ordenarImporte: 0,
    };
  },
  computed: {
    ...mapState(["permiso"]),
    getTotalVentas() {
      let total = 0;
      let vm = this;
      this.dateInform.forEach(function (d) {
        total += d.amount;
      });
      return total;
    },
    urlExportPDF() {
      return (
        this.$store.getters.apiUrl +
        "/sales/exportValesClientes/PDF?idTpv=" +
        this.idTpv +
        "&idBusiness=" +
        this.idBusiness +
        "&datefrom=" +
        moment(this.datefrom).startOf("day").unix() +
        "&dateto=" +
        moment(this.dateto).endOf("day").unix() +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
    urlExportExcel() {
      return (
        this.$store.getters.apiUrl +
        "/sales/exportValesClientes/Excel?idTpv" +
        this.idTpv +
        "&idBusiness=" +
        this.idBusiness +
        "&idTpv=" +
        this.idTpv +
        "&datefrom=" +
        moment(this.datefrom).startOf("day").unix() +
        "&dateto=" +
        moment(this.dateto).endOf("day").unix() +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
    getTotalVales() {
      let total = 0;
      let vm = this;
      this.dateInform.forEach(function (d) {
        total += parseFloat(d.total);
      });
      return total;
    },
  },
  methods: {
    sortedArrayASC: function (nameAtributo) {
      switch (nameAtributo) {
        case 1:
          this.ordenarFecha = 1;

          function compareFecha(a, b) {
            if (a.date.toUpperCase() < b.date.toUpperCase()) return -1;
            if (a.date.toUpperCase() > b.date.toUpperCase()) return 1;
            return 0;
          }

          return this.dateInform.sort(compareFecha);

        case 2:
          this.ordenarOperacion = 1;

          function compareOperacion(a, b) {
            if (a.workerName.toUpperCase() < b.workerName.toUpperCase())
              return -1;
            if (a.workerName.toUpperCase() > b.workerName.toUpperCase())
              return 1;
            return 0;
          }

          return this.dateInform.sort(compareOperacion);

        case 3:
          this.ordenarImporte = 1;

          function compareImporte(a, b) {
            if (a.amount < b.amount) return -1;
            if (a.amount > b.amount) return 1;
            return 0;
          }

          return this.dateInform.sort(compareImporte);
      }
    },
    sortedArrayDESC: function (nameAtributo) {
      switch (nameAtributo) {
        case 1:
          this.ordenarFecha = 0;

          function compareFecha(a, b) {
            if (a.date.toUpperCase() > b.date.toUpperCase()) return -1;
            if (a.date.toUpperCase() < b.date.toUpperCase()) return 1;
            return 0;
          }

          return this.dateInform.sort(compareFecha);

        case 2:
          this.ordenarOperacion = 0;

          function compareOperacion(a, b) {
            if (a.workerName.toUpperCase() > b.workerName.toUpperCase())
              return -1;
            if (a.workerName.toUpperCase() < b.workerName.toUpperCase())
              return 1;
            return 0;
          }

          return this.dateInform.sort(compareOperacion);

        case 3:
          this.ordenarImporte = 0;

          function compareImporte(a, b) {
            if (a.amount > b.amount) return -1;
            if (a.amount < b.amount) return 1;
            return 0;
          }

          return this.dateInform.sort(compareImporte);
      }
    },

    getBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function (response) {
          vm.listBusinesses = response.data.result;

          if (vm.$store.getters.idBusiness) {
            vm.idBusiness = vm.$store.getters.idBusiness;
          } else {
            vm.idBusiness = response.data.result[0].id;
          }

          vm.cambioTpv(-1, false);
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    openModal(index) {
      this.indice = index;

      this.$modal.show("desgloseModal");
    },

    cerrarModal() {
      this.$modal.hide("desgloseModal");
    },

    cambioBusiness(idBusinessData, listTpv) {
      if (listTpv) {
        this.listTpv = listTpv;
      }
      this.loading = Loading.service({ text: "Cargando..." });
      this.idBusiness = idBusinessData;
      this.idTpv = -1;
      this.list = [];
      this.cambioTpv();
    },
    emitirConsulta() {
      this.getVales();
    },
    cambioTpv(idTpvData, filtrar) {
      if (idTpvData != undefined) {
        this.idTpv = idTpvData;
      }

      this.emitirConsulta();
    },
    cambioHora(dates) {
      this.datefrom = dates[0];
      this.dateto = dates[1];
    },

    getTpv() {
      this.listTpv = [];

      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
        .then(function (response) {
          if (response.data.response) {
            vm.listTpv = response.data.result;
            if (vm.listTpv.length > 0) {
              vm.idTpv = -1;
              vm.getVales();
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally((_) => {
          vm.loading.close();
        });
    },

    getVales() {      

      if (this.datefrom === null || this.dateto === null) {
        swal({
          title: this.$t("ups"),
          text: this.$t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else {
        let secondsDesde = moment(this.datefrom).unix();
        let secondsHasta = moment(this.dateto).unix();

        if (secondsHasta < secondsDesde) {
          swal({
            title: this.$t("ups"),
            text: this.$t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });
        } else {
          this.$store.dispatch("setDateTo", this.dateto);
          this.$store.dispatch("setDateFrom", this.datefrom);

          this.loading = Loading.service({ text: "Cargando..." });

          let idTpvAMandar = "";
          if (this.idTpv == -1) {
            idTpvAMandar = 0;
          } else {
            idTpvAMandar = this.idTpv;
          }

          var config = {
            params: {
              idTpv: idTpvAMandar,
              idBusiness: this.idBusiness,
              datefrom: moment(this.datefrom).startOf("day").unix(),
              dateto: moment(this.dateto).endOf("day").unix(),
              jwt: this.$store.getters.jwt,
            },
            headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          };

          let vm = this;
          this.$store.dispatch("setIdBusiness", this.idBusiness);
          this.axios
            .get(this.$store.getters.apiUrl + "sales/getVales", config)
            .then(function (response) {
              if (response.data.response) {
                vm.dateInform = response.data.result;
                vm.respuesta = true;
              }else if (response.data.response == false && response.data.rangoMayor == true) {
                  swal({
                  title: "Lo sentimos",
                  text: response.data.result,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "info",
                  });
                  vm.respuesta = false;
              } else {
                swal({
                  title: vm.$t("atencion"),
                  text: response.data.message,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "error",
                });
                vm.respuesta = false;
              }
              vm.loading.close();
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      }
    },
    getClassDay(date) {
      var classDay = "";
      var humanDate = moment.unix(date);
      var dia = moment(humanDate).format("d");

      if (dia === "0") {
        classDay = "sunday";
      } else if (dia == 5 || dia == 6) {
        classDay = "fridaySaturday";
      }

      return classDay;
    },
  },
};
</script>

<style scoped>
a li {
  color: #111;
}

.card {
  padding: 20px;
}

.div-export {
  margin-bottom: 10px;
}
</style>




// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Ventas/Widgets/Vales.vue